import getCollapsedSelectionForClipboard from '../get-collapsed-selection-for-clipboard';
import { DEFAULT_BLOCK_TAG } from '../../constants/editable-elements';

const insertWithFormatting = (elements, nodeToReplace, firstBlockElement) => {
  const pasteElements = document.createDocumentFragment();
  // check for block node in pasted elements
  // if we insert inline nodes as is, then <p> wrapper will be created for each node
  if (!firstBlockElement) {
    const p = document.createElement(DEFAULT_BLOCK_TAG);
    p.append(...elements);
    pasteElements.append(p);
  } else {
    pasteElements.append(...elements);
  }
  nodeToReplace.replaceWith(pasteElements);
  return getCollapsedSelectionForClipboard(elements);
};

export default insertWithFormatting;
